import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Label,
} from "recharts";

const SingleBarChart = ({ data }) => {
  // Transform API structure if needed
  const chartData =
    data && data?.labels && data?.data
      ? data?.labels?.map((label, index) => ({
          month: label,
          value: data?.data[index],
        }))
      : data; // if already in correct format, use it as is

  if (!chartData || chartData?.length === 0) {
    return (
      <div className="w-full h-[250px] flex flex-col items-center justify-center border border-gray-200 rounded-lg bg-gray-50">
        <p className="text-[##005C53] text-lg">No data available</p>
      </div>
    );
  }

  // Dynamically calculate Y-axis max value
  const maxValue = Math?.max(...chartData?.map((d) => d?.value));
  return (
    <ResponsiveContainer width="100%" height={250}>
      <BarChart
        data={chartData}
        margin={{ top: 20, right: 30, left: 0, bottom: 20 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" axisLine={{ stroke: "#D9D9D9" }}>
          <Label
            value={data?.bucket === "week" ? "Weeks" : "Months"}
            position="insideBottom"
            offset={-10}
          />
        </XAxis>
        <YAxis domain={[0, maxValue + 5]} axisLine={{ stroke: "#D9D9D9" }} />
        <Tooltip />
        <Bar dataKey="value" fill="#005C53" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default SingleBarChart;
